
export default {
  name: 'BaseContainer',
}
